function Role() {
  this.role_level = '';
  this.role_name = '';
  this.role_server_id = '';
  this.role_server_name = '';
  this.role_id = '';
  this.role_type = '';
  this.role_gender = '';
  this.association_id = '';
  this.association_name = '';
  this.association_rank = '';
}

Role.prototype = {
  constructor: Role,
};

export default Role;



// WEBPACK FOOTER //
// ./src/common/js/model/Role.js